<template>
  <PageShell active="about">
    <section class="contact-page">
      <h1>Contact Us</h1>
      <h2>Contact Form</h2>
      <form class="contact-form" @submit.prevent="sendMessage">
        <label>
          <span><b>*</b>Your name</span>
          <input v-model.trim="form.name" type="text" maxlength="100">
        </label>
        <label>
          <span><b>*</b>Contact E-Mail</span>
          <input v-model.trim="form.email" type="email" placeholder="Please enter" maxlength="120">
        </label>
        <label class="message-field">
          <span><b>*</b>Message<small>Not more than<br>5000 characters</small></span>
          <textarea v-model.trim="form.message" maxlength="5000"></textarea>
        </label>
        <button type="submit" :disabled="loading">{{ loading ? 'Sending...' : 'Send' }}</button>
      </form>
    </section>
  </PageShell>
</template>

<script>
import PageShell from '@/components/common/PageShell.vue'

export default {
  name: 'ContactPage',
  components: { PageShell },
  data() {
    return {
      form: { name: '', email: '', message: '' },
      loading: false
    }
  },
  methods: {
    async sendMessage() {
      if (!this.form.name || !this.form.email || !this.form.message) {
        this.$message.warning('Please complete all required fields')
        return
      }
      if (!/^\S+@\S+\.\S+$/.test(this.form.email)) {
        this.$message.warning('Please enter a valid email address')
        return
      }
      this.loading = true
      try {
        const res = await this.$api({
          url: 'Contact/submit',
          method: 'post',
          data: {
            name: this.form.name,
            email: this.form.email,
            content: this.form.message
          }
        })
        this.$message.success(res.message || 'Your message has been submitted successfully')
        this.form = { name: '', email: '', message: '' }
      } catch (e) {
        this.$message.error((e && (e.message || e.msg)) || 'Failed to submit your message')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.contact-page {
  max-width: 1100px;
  margin: 0 auto;
  padding: 36px 0 112px;
}

h1,
h2 {
  margin: 0;
  color: #171717;
  font-weight: 400;
}

h1 {
  font-size: 30px;
  line-height: 1.2;
}

h2 {
  margin-top: 46px;
  font-size: 21px;
  line-height: 1.3;
}

.contact-form {
  width: 974px;
  min-height: 483px;
  margin-top: 31px;
  padding: 66px 68px 48px 78px;
  border: 1px solid #f0d8d0;
  border-radius: 9px;
  background: #fff1ed;
}

.contact-form label {
  display: grid;
  grid-template-columns: 152px 1fr;
  column-gap: 28px;
  margin-bottom: 28px;
}

.contact-form label>span {
  padding-top: 13px;
  color: #151515;
  font-size: 16px;
  line-height: 1.3;
  text-align: right;
}

.contact-form b {
  color: #f03424;
  font-weight: 400;
}

.contact-form small {
  display: block;
  margin-top: 16px;
  color: #9b9b9b;
  font-size: 16px;
  line-height: 1.35;
}

.contact-form input,
.contact-form textarea {
  width: 100%;
  border: 1px solid #dedede;
  border-radius: 8px;
  background: #fff;
  color: #222;
  font-size: 16px;
}

.contact-form input {
  height: 48px;
  padding: 0 14px;
}

.contact-form textarea {
  height: 136px;
  padding: 12px 14px;
  outline: none;
  resize: vertical;
}

.contact-form input::placeholder {
  color: #aaa;
}

.contact-form .message-field {
  margin-bottom: 34px;
}

.contact-form button {
  width: 146px;
  height: 44px;
  margin-left: 180px;
  border: 0;
  border-radius: 4px;
  background: #f34b01;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
}

.contact-form button:hover {
  background: #df4400;
}

.contact-form button:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

@media (max-width: 700px) {
  .contact-page {
    min-height: auto;
    padding: 30px 0 60px;
  }

  h1 {
    font-size: 27px;
  }

  .contact-form {
    width: 100%;
    min-height: 0;
    padding: 28px 20px;
    border-radius: 6px;
  }

  .contact-form label {
    grid-template-columns: 1fr;
    column-gap: 0;
    row-gap: 9px;
    margin-bottom: 20px;
  }

  .contact-form label>span {
    padding: 0;
    text-align: left;
  }

  .contact-form small {
    display: inline;
    margin-left: 8px;
    font-size: 13px;
  }

  .contact-form button {
    margin-left: 0;
  }
}
</style>
